import React, { useEffect, useState } from "react";
import DropDown from "../ReusableComponents/DropDown";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import InputText from "../ReusableComponents/InputText";
import { BindAPI, BindPostAPI, IUDAPI } from "../services/APIConnection";
import { mainTable } from "../css/Common";
import AddScreenTitle from "../components/AddScreenTitle";
import toast from "react-hot-toast";
import Buttons from "../components/Buttons";
import MainLayout from "../components/MainLayout";
import { openingStockHeader } from "../components/HeaderAttribute";
import GridPage from "../components/GridPage";
import MainPopup from "../popup-containers/MainPopup";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import PopUpButtons from "../components/PopUpButtons";
import OpeningstockPopup from "../popup-containers/OpeningstockPopup";
import Loader from "../ReusableComponents/Loader";
import ErrorPopup from "../ReusableComponents/ErrorPopup";

const OpeningStock = () => {
  const [popUpOpen, setpopUpOpen] = useState(false);
  const [popupTableData, setPopupTableData] = useState([]);
  const [addScreenTitle, setAddScreenTitle] = useState(true);
  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const [tableError, setTableError] = useState("");
  const [rowErrors, setRowErrors] = useState({});
  const [isTableEnabled, setIsTableEnabled] = useState(false);
  const [formFields, setFormFields] = useState({
    itemType: "",
    opStkId: "",
  });
  const [errors, setErrors] = useState({});
  const [isOpen, setIsOpen] = useState(false);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  const [rowIndex, setRowIndex] = useState(false);
  const [viewDetails, setViewDetails] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [OpeningStockData, setOpeningstockData] = useState([]);
  const [openingStocks, setOpeningStocks] = useState("");
  const [itemTypeOptions, setitemTypeOptions] = useState([]);
  const [itemsOptions, setitemsOptions] = useState([]);
  const [ItemNameOptions, setItemNameOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [allItemCategories, setAllItemCategories] = useState([]);
  const [allItemNames, setAllItemNames] = useState([]);
  const [TxnOpeningstockId, setTxnOpeningstockId] = useState("");

  const createdBy = sessionStorage.getItem("createdBy");
  const mstClientId = sessionStorage.getItem("MstClientId");

  const [tableData, setTableData] = useState([
    {
      MstItemcategoryId: "",
      MstItemId: "",
      DateofOpeningStock: new Date().toISOString().split("T")[0],
      Quantity: "",
      UOM: "",
      Value: "",
      IssuedQuantity: 0,
      Difference: 0,
    },
  ]);

  const [bindOpeningStockData, setBindOpeningStockData] = useState([]);

  useEffect(() => {
    fetchOpeningStockDropdowns();
  }, []);

  const fetchOpeningStockDropdowns = async () => {
    const data = { mstClientId: mstClientId };
    try {
      setIsLoading(true);
      const response = await BindPostAPI(
        data,
        "OpeningAPI/BindOpeningStocknew"
      );
      if (response?.data) {
        const data = response.data;
        if (data.Table) {
          setBindOpeningStockData(data.Table);
        }
        if (data.Table1) {
          setitemTypeOptions(
            data.Table1.map((item) => ({
              value: item.MstItemTypeId,
              label: item.ItemType,
            }))
          );
        }
        if (data.Table2) {
          const mappedCategories = data.Table2.map((item) => ({
            value: item.MstItemCategoryId,
            label: item.ItemCategory,
            MstItemTypeId: item.MstItemTypeId,
          }));
          setAllItemCategories(mappedCategories);
          setitemsOptions(mappedCategories);
        }
        if (data.Table3) {
          const mappedItems = data.Table3.map((item) => ({
            value: item.MstItemId,
            label: item.ItemName,
            MstItemCategoryId: item.MstItemCategoryId,
            MstUOMId: item.UOM,
          }));
          setAllItemNames(mappedItems);
          setItemNameOptions(mappedItems);
        }
      }
    } catch (error) {
      console.error("Error binding OpeningStock dropdowns:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleItemBlur = (input, rowIndex, columnName) => {
    const value = 0;
    // const value = input?.target ? input.target.value : input?.value || "";
    setTableData((prevTableData) => {
      const updatedData = [...prevTableData];
      const updatedRow = { ...updatedData[rowIndex] };
      let newRowErrors = { ...rowErrors };

      let duplicateError = "";
      if (columnName === "MstItemcategoryId" || columnName === "MstItemId") {
        const MstItemcategoryId =
          columnName === "MstItemcategoryId"
            ? value
            : tableData.MstItemcategoryId;
        const currentItem =
          columnName === "MstItemId" ? value : tableData.MstItemId;

        // const isDuplicate = updatedData.some(
        //   (row, index) =>
        //     index !== rowIndex &&
        //     row.MstItemcategoryId == currentCategory &&
        //     row.MstItemId == currentItem &&
        //     currentCategory !== "" &&
        //     currentItem !== ""
        // );
        const isDuplicate = bindOpeningStockData.some((row, index) =>
          tableData.some(
            (otherRow, otherIndex) =>
              index !== otherIndex &&
              row.MstItemcategoryId === otherRow.MstItemcategoryId &&
              row.MstItemId === otherRow.MstItemId &&
              row.MstItemcategoryId !== "" &&
              row.MstItemId !== ""
          )
        );

        if (isDuplicate) {
          duplicateError =
            "Duplicate Item Category and Item Name combination is not allowed";
          toast.error(duplicateError);
          setTableError(duplicateError);
          return prevTableData; // Prevent state update
        } else {
          if (newRowErrors[rowIndex]?.includes("Duplicate")) {
            delete newRowErrors[rowIndex];
          }
        }
      }

      setRowErrors(newRowErrors);
      setTableError(
        Object.keys(newRowErrors).length > 0
          ? "One or more rows have validation errors."
          : ""
      );

      updatedRow[columnName] = value;
      updatedData[rowIndex] = updatedRow;
      convertArrayToJSONString(updatedData);
      return updatedData;
    });
  };

  const handleQuantityBlur = (e, index) => {
    const value = e.target.value;
    const updatedRow = tableData[index];
    let newRowErrors = { ...rowErrors };

    const existing = bindOpeningStockData.find(
      (x) =>
        x.TxnOpeningstockId === updatedRow.TxnOpeningstockId &&
        x.MstItemId === updatedRow.MstItemId
    );

    if (existing && value !== "") {
      const issued = parseFloat(existing.Difference || 0);
      const enteredQty = parseFloat(value || 0);
      if (enteredQty < issued) {
        newRowErrors[
          index
        ] = `Quantity cannot be less than difference (${issued})`;
      } else {
        delete newRowErrors[index];
      }
    } else {
      delete newRowErrors[index];
    }

    setRowErrors(newRowErrors);
    setTableError(
      Object.keys(newRowErrors).length > 0
        ? "One or more rows have validation errors."
        : ""
    );
  };

  const handleSubmit = async (items, flag) => {
    setSubmitBtnDisabled(true);
    setIsLoading(true);

    try {
      const createdBy = sessionStorage.getItem("createdBy");

      if (flag === 1 || flag === 2) {
        if (!formFields.itemType) {
          setErrors({ itemType: "Select Item Type" });
          setIsOpen(true);
          setSubmitBtnDisabled(false);
          setIsLoading(false);
          return;
        }

        const openingStocksData = tableData;
        const jsonString = JSON.stringify(openingStocksData);
        setOpeningStocks(jsonString);

        const duplicates = tableData.some((row, index) =>
          tableData.some(
            (otherRow, otherIndex) =>
              index !== otherIndex &&
              row.MstItemcategoryId === otherRow.MstItemcategoryId &&
              row.MstItemId === otherRow.MstItemId &&
              row.MstItemcategoryId !== "" &&
              row.MstItemId !== ""
          )
        );

        if (duplicates) {
          toast.error(
            "Duplicate Item Category and Item Name combination is not allowed."
          );
          setTableError(
            "Duplicate Item Category and Item Name combination is not allowed"
          );
          setSubmitBtnDisabled(false);
          setIsLoading(false);
          return;
        }

        const hasInvalidRow = openingStocksData.some(
          (row) =>
            !row.MstItemcategoryId ||
            !row.MstItemId ||
            !row.DateofOpeningStock ||
            !row.Quantity ||
            !row.UOM ||
            !row.Value
        );

        const isDuplicate = tableData.some((row) =>
          bindOpeningStockData.some(
            (existing) =>
              existing.MstItemcategoryId === row.MstItemcategoryId &&
              existing.MstItemId === row.MstItemId &&
              (flag === 1 ||
                existing.TxnOpeningstockId !== row.TxnOpeningstockId)
          )
        );

        if (isDuplicate) {
          toast.error(
            "Stock already exists for this Item Category and Item Name."
          );
          setSubmitBtnDisabled(false);
          setIsLoading(false);
          return;
        }

        const hasInvalidQty = tableData.some((row) => {
          const existing = bindOpeningStockData.find(
            (x) =>
              x.TxnOpeningstockId === row.TxnOpeningstockId &&
              x.MstItemId === row.MstItemId
          );
          if (!existing) return false;
          const issued = parseFloat(existing.Difference || 0);
          return parseFloat(row.Quantity) < parseFloat(issued);
        });

        if (hasInvalidQty) {
          toast.error("Quantity cannot be less than difference ❌");
          setSubmitBtnDisabled(false);
          setIsLoading(false);
          return;
        }

        if (openingStocksData.length === 0) {
          setTableError("Please add at least one item in the table.");
          setIsOpen(true);
          setSubmitBtnDisabled(false);
          setIsLoading(false);
          return;
        }

        if (hasInvalidRow) {
          setTableError("Please fill all required fields in the table.");
          setIsOpen(true);
          setSubmitBtnDisabled(false);
          setIsLoading(false);
          return;
        }

        // if (hasInvalidRow || openingStocksData.length === 0) {
        //   //  toast.error("Please fill all required fields in the table.");
        //   // toast.error("Please enter all mandatory fields.");
        //   setTableError("Please fill the above table");
        //   setIsOpen(true);
        //   setSubmitBtnDisabled(false);
        //   setIsLoading(false);
        //   return;
        // }

        const payload = {
          txnOpeningstockId: TxnOpeningstockId ? TxnOpeningstockId : 0,
          mstClientId: mstClientId,
          opStkId: formFields.opStkId ? formFields.opStkId : "",
          mstItemTypeId: formFields.itemType,
          iN_SOpeningStock: jsonString,
          createdBy: createdBy,
          flag: flag,
        };

        const response = await IUDAPI(
          payload,
          "OpeningAPI/IUD_TxnOpeningStock"
        );
        const result = response?.data?.Table?.[0]?.Result;

        if (flag === 1 && result === "S") {
          toast.success("Opening Stock inserted successfully 👍");
          setTimeout(cancel, 3000);
        } else if (flag === 2 && response?.data?.Table?.[0]?.Result === "M") {
          toast.success("Opening Stock updated successfully 👍");
          setTimeout(cancel, 3000);
        } else {
          toast.error("Failed to save Opening Stock 👎");
          setSubmitBtnDisabled(false);
          setIsLoading(false);
        }
      } else if (flag === 3) {
        if (!bindOpeningStockData[items]) {
          toast.error("Invalid record selected for deletion.");
          setSubmitBtnDisabled(false);
          setIsLoading(false);
          return;
        }

        const deletePayload = {
          txnOpeningstockId: bindOpeningStockData[items].TxnOpeningstockId,
          mstClientId: mstClientId,
          mstItemTypeId: 0,
          iN_SOpeningStock: JSON.stringify([
            {
              TxnOpeningstockId: bindOpeningStockData[items].TxnOpeningstockId,
            },
          ]),
          createdBy: createdBy,
          flag: 3,
        };

        const deleteResponse = await IUDAPI(
          deletePayload,
          "OpeningAPI/IUD_TxnOpeningStock"
        );
        const deleteResult = deleteResponse?.data?.Table?.[0]?.Result;

        if (deleteResult === "D") {
          toast.success("Opening Stock deleted successfully 🗑️");
          setTimeout(cancel, 3000);
        } else {
          toast.error(
            `Failed to delete: ${
              deleteResponse?.data?.Table?.[0]?.Message || "Unknown error"
            }`
          );
          setSubmitBtnDisabled(false);
          setIsLoading(false);
        }
      }
    } catch (error) {
      console.error("Error during submission:", error);
      toast.error("An unexpected error occurred.");
      setSubmitBtnDisabled(false);
      setIsLoading(false);
    }
  };

  const showAdd = () => {
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(true);
    setUpdateScreenTitle(false);
  };

  const handleStock = (rowIndex, flag) => {
    setRowIndex(rowIndex);
    setpopUpOpen(true);

    if (flag === 1) {
      setViewDetails(true);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 3) {
      setViewDetails(false);
      setDeleteDetails(true);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 4) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(true);
      setUnBlockDetails(false);
    } else if (flag === 5) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(true);
    }

    const rowData = bindOpeningStockData[rowIndex];
    if (!rowData) {
      console.error(`Row data at index ${rowIndex} is undefined`);
      setOpeningstockData([]);
      setTableData([]);
      return;
    }

    const filterItemType = itemTypeOptions.filter(
      (x) => x.value === rowData.MstItemTypeId
    );

    const filterItemCategory = allItemCategories
      .filter((x) => x.MstItemTypeId === rowData.MstItemTypeId)
      .map((item) => ({
        value: item.MstItemCategoryId,
        label: item.ItemCategory,
      }))
      .filter((j) => j.value === rowData.MstItemcategoryId);

    const filterItemName = allItemNames
      .filter((x) => x.MstItemCategoryId === rowData.MstItemcategoryId)
      .map((item) => ({
        value: item.MstItemId,
        label: item.ItemName,
      }))
      .filter((j) => j.value === rowData.MstItemId);

    const formattedTableData = [
      {
        MstItemcategoryId: rowData.MstItemcategoryId || "",
        MstItemCategoryName:
          allItemCategories.find((x) => x.value === rowData.MstItemcategoryId)
            ?.label || "N/A",
        MstItemId: rowData.MstItemId || "",
        MstItemName:
          allItemNames.find((x) => x.value === rowData.MstItemId)?.label ||
          "N/A",
        DateofOpeningStock: rowData.DateofOpeningStock
          ? rowData.DateofOpeningStock.includes("T")
            ? rowData.DateofOpeningStock.split("T")[0]
            : rowData.DateofOpeningStock
          : new Date().toISOString().split("T")[0],
        Quantity: rowData.Quantity || "",
        UOM: rowData.UOM || "",
        Value: rowData.Value || "",
      },
    ];

    const popupData = [
      rowData.MstItemTypeId || "",
      filterItemType,
      filterItemCategory,
      filterItemName,
      rowData.UOM || "",
    ];

    setPopupTableData(formattedTableData);
    setOpeningstockData(popupData);
  };

  const handleEdit = (rowIndex) => {
    setSubmitBtnDisabled(false);
    const selectedRow = bindOpeningStockData[rowIndex];
    if (!selectedRow) return;

    const selectedTxnId = selectedRow.TxnOpeningstockId;
    const relatedRows = bindOpeningStockData.filter(
      (row) => row.TxnOpeningstockId === selectedTxnId
    );

    setUpdateScreenTitle(true);
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(false);

    setTxnOpeningstockId(selectedTxnId || "");
    setFormFields({
      itemType: selectedRow.MstItemTypeId || "",
      opStkId: selectedRow.OpStkId || "",
    });

    const filteredCategories = allItemCategories.filter(
      (cat) => cat.MstItemTypeId === selectedRow.MstItemTypeId
    );
    setitemsOptions(filteredCategories);

    const filteredItems = allItemNames.filter(
      (item) => item.MstItemCategoryId === selectedRow.MstItemcategoryId
    );
    setItemNameOptions(filteredItems);

    const editableTableData = relatedRows.map((row) => ({
      TxnOpeningstockId: row.TxnOpeningstockId,
      MstItemcategoryId: row.MstItemcategoryId || "",
      MstItemId: row.MstItemId || "",
      DateofOpeningStock: row.DateofOpeningStock
        ? row.DateofOpeningStock.includes("T")
          ? row.DateofOpeningStock.split("T")[0]
          : row.DateofOpeningStock
        : new Date().toISOString().split("T")[0],
      Quantity: row.Quantity || "",
      UOM: row.UOM || "",
      Value: row.Value || "",
      IssuedQuantity: row.IssuedQuantity,
      Difference: row.Difference,
    }));

    setTableData(editableTableData);
  };

  const handleInputChangeForm = (e) => {
    const { name, value } = e.target;
    setFormFields((prev) => ({ ...prev, [name]: value }));
  };

  const handleAutoDropdownChange = (value, name) => {
    setFormFields((prev) => ({ ...prev, [name]: value }));

    if (name === "itemType") {
      const filteredCategories = allItemCategories.filter(
        (cat) => cat.MstItemTypeId === value
      );
      setitemsOptions(filteredCategories);
      setItemNameOptions([]);
      setIsTableEnabled(!!value);
    }
  };

  const convertArrayToJSONString = (array) => {
    try {
      const jsonString = JSON.stringify(array);
      setOpeningStocks(jsonString);
      return jsonString;
    } catch (error) {
      console.error("Error converting array to JSON string:", error);
      return null;
    }
  };

  const handleInputChange = (input, rowIndex, columnName) => {
    const value = input?.target ? input.target.value : input?.value || "";
    setTableData((prevTableData) => {
      const updatedData = [...prevTableData];
      const updatedRow = { ...updatedData[rowIndex] };
      let newRowErrors = { ...rowErrors };

      if (columnName === "MstItemTypeId") {
        updatedRow.MstItemTypeId = value;
        updatedRow.MstItemcategoryId = "";
        updatedRow.MstItemId = "";
        updatedRow.UOM = "";
        const filteredCategories = allItemCategories.filter(
          (cat) => cat.MstItemTypeId === value
        );
        setitemsOptions(filteredCategories);
        setItemNameOptions([]);
      }

      if (columnName === "MstItemcategoryId") {
        updatedRow.MstItemcategoryId = value;
        updatedRow.MstItemId = "";
        updatedRow.UOM = "";
        const filteredItems = allItemNames.filter(
          (item) => item.MstItemCategoryId === value
        );
        setItemNameOptions(filteredItems);
      }

      if (columnName === "MstItemId") {
        updatedRow.MstItemId = value;
        const selectedItem = allItemNames.find((item) => item.value === value);
        updatedRow.UOM = selectedItem?.MstUOMId || "";
      }

      if (columnName === "Quantity") {
        let qty = parseFloat(value);

        // Prevent negatives
        if (isNaN(qty) || qty < 0) {
          qty = 0; // fallback to 0 if negative or invalid
        }

        updatedRow.Quantity = qty;

        const existing = bindOpeningStockData.find(
          (x) =>
            x.TxnOpeningstockId === updatedRow.TxnOpeningstockId &&
            x.MstItemId === updatedRow.MstItemId
        );

        if (existing) {
          const issued = parseFloat(existing.Difference || 0);
          if (qty < issued) {
            newRowErrors[
              rowIndex
            ] = `Quantity cannot be less than difference (${issued})`;
          } else {
            delete newRowErrors[rowIndex];
          }
        } else {
          delete newRowErrors[rowIndex];
        }
      }
      //       let duplicateError = "";
      //       if (columnName === "MstItemcategoryId" || columnName === "MstItemId") {
      //         const MstItemcategoryId =
      //           columnName === "MstItemcategoryId" ? value : tableData.MstItemcategoryId;
      //         const currentItem =
      //           columnName === "MstItemId" ? value : tableData.MstItemId;

      //         const isDuplicate = tableData.some(
      //           (row, index) =>
      //             index !== rowIndex &&
      //             row.MstItemcategoryId == MstItemcategoryId &&
      //             row.MstItemId == currentItem &&
      //             MstItemcategoryId !== "" &&
      //             currentItem !== ""
      //         );

      //         // const isDuplicate = bindOpeningStockData.some((row, index) =>
      //         //   tableData.some(
      //         //     (otherRow, otherIndex) =>
      //         //       index !== otherIndex &&
      //         //       row.MstItemcategoryId === otherRow.MstItemcategoryId &&
      //         //       row.MstItemId === otherRow.MstItemId &&
      //         //       row.MstItemcategoryId !== "" &&
      //         //       row.MstItemId !== ""
      //         //   )
      //         // );
      //
      //         if (isDuplicate) {
      //           duplicateError = "Duplicate Item Category and Item Name combination is not allowed";
      //           toast.error(duplicateError);
      //           setTableError(duplicateError);
      //           return prevTableData; // Prevent state update
      //         } else {
      //           if (newRowErrors[rowIndex]?.includes("Duplicate")) {
      //             delete newRowErrors[rowIndex];
      //           }
      //         }
      //       }

      const openingStocksData = tableData;
      const jsonString = JSON.stringify(openingStocksData);
      setOpeningStocks(jsonString);

      const duplicates = tableData.some((row, index) =>
        tableData.some(
          (otherRow, otherIndex) =>
            index !== otherIndex &&
            row.MstItemcategoryId === otherRow.MstItemcategoryId &&
            row.MstItemId === otherRow.MstItemId &&
            row.MstItemcategoryId !== "" &&
            row.MstItemId !== ""
        )
      );

      if (duplicates) {
        toast.error(
          "Duplicate Item Category and Item Name combination is not allowed."
        );
        setTableError(
          "Duplicate Item Category and Item Name combination is not allowed"
        );
        setSubmitBtnDisabled(false);
        setIsLoading(false);
        return;
      }

      setRowErrors(newRowErrors);
      setTableError(
        Object.keys(newRowErrors).length > 0
          ? "One or more rows have validation errors."
          : ""
      );

      updatedRow[columnName] = value;
      updatedData[rowIndex] = updatedRow;
      convertArrayToJSONString(updatedData);
      return updatedData;
    });
  };

  const handleAddRow = () => {
    const lastRow = tableData[tableData.length - 1];
    if (lastRow && lastRow.MstItemcategoryId && lastRow.MstItemId) {
      const isDuplicate = tableData.some(
        (row, index) =>
          index !== tableData.length - 1 &&
          row.MstItemcategoryId === lastRow.MstItemcategoryId &&
          row.MstItemId === lastRow.MstItemId
      );

      if (isDuplicate) {
        toast.error("Item with the same category and name already exists.");
        setTableError("Item with the same category and name already exists.");
        return;
      }
    } else {
      // toast.error("Please select both Item Category and Item Name before adding a new row.");
      setTableError(
        "Please select both Item Category and Item Name before adding a new row."
      );
      return;
    }

    setTableData([
      ...tableData,
      {
        MstItemcategoryId: "",
        MstItemId: "",
        DateofOpeningStock: new Date().toISOString().split("T")[0],
        Quantity: "",
        UOM: "",
        Value: "",
        IssuedQuantity: 0,
        Difference: 0,
      },
    ]);
    setTableError(""); // Clear error when adding a new row
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    const newErrors = { ...errors };

    if (!value) {
      if (name === "itemType") {
        newErrors[name] = "Select Item Type";
      } else {
        newErrors[name] = "This field is required";
      }
    } else {
      delete newErrors[name];
    }

    setErrors(newErrors);
  };

  const handleDeleteRow = (index) => {
    if (index === 0) {
      const updated = [...tableData];
      updated[0] = {
        MstItemcategoryId: "",
        MstItemId: "",
        DateofOpeningStock: new Date().toISOString().split("T")[0],
        Quantity: "",
        UOM: "",
        Value: "",
        IssuedQuantity: 0,
        Difference: 0,
      };
      setTableData(updated);
    } else {
      // Remove row for other indexes
      setTableData((prev) => prev.filter((_, i) => i !== index));
    }
  };
  const cancel = () => {
    setVisibleAdd(false);
    setSubmitBtnDisabled(false);
    setVisibleTable(true);
    setAddScreenTitle(false);
    setUpdateScreenTitle(false);
    setpopUpOpen(false);
    setIsLoading(false);
    setTxnOpeningstockId("");
    setFormFields({ itemType: "" });
    setRowErrors({});
    setErrors({});
    setTableError("");
    setTableData([
      {
        MstItemcategoryId: "",
        MstItemId: "",
        DateofOpeningStock: new Date().toISOString().split("T")[0],
        Quantity: "",
        UOM: "",
        Value: "",
      },
    ]);
    fetchOpeningStockDropdowns();
  };

  return (
    <MainLayout pageName={"2"}>
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      {visibleTable && (
        <GridPage
          header={openingStockHeader}
          title={"Opening Stock"}
          records={bindOpeningStockData}
          handleEdit={handleEdit}
          handleAction={handleStock}
          showAdd={showAdd}
          blockview={true}
        />
      )}
      {visibleAdd && (
        <div className="w-full">
          <div className="flex flex-col w-full">
            <div className={mainTable.clientMasterMainAdd}>
              <AddScreenTitle
                addScreenTitle={addScreenTitle}
                updateScreenTitle={updateScreenTitle}
                title="Opening Stock"
              />
            </div>
          </div>
          <div className={mainTable.addShadowScreen}>
            <div className={mainTable.mainContentScreen}>
              <div className={mainTable.grid3}>
                <AutoDropDown
                  name="itemType"
                  title="Item Type"
                  selectedOption={itemTypeOptions.find(
                    (x) => x.value === formFields.itemType
                  )}
                  classStar="text-red-500"
                  options={itemTypeOptions}
                  placeholder="Select Item Type"
                  Class="custom-class"
                  disabled={false}
                  controlFunc={(value, e) => {
                    handleAutoDropdownChange(value.value, "itemType");
                    setTableData([
                      {
                        MstItemcategoryId: "",
                        MstItemId: "",
                        DateofOpeningStock: new Date()
                          .toISOString()
                          .split("T")[0],
                        Quantity: "",
                        UOM: "",
                        Value: "",
                        IssuedQuantity: 0,
                        Difference: 0,
                      },
                    ]);
                  }}
                  controlFuncBlur={(e) =>
                    handleBlur({
                      target: { name: "itemType", value: formFields.itemType },
                    })
                  }
                />
              </div>
              {errors?.itemType && (
                <span className="text-red-600 font-semibold text-sm">
                  {errors.itemType}
                </span>
              )}

              <table className="w-full border border-gray-300 mt-6">
                <thead className="bg-[#3D6643] text-white sticky top-0 z-10">
                  <tr>
                    <th className="border px-4 py-2 w-16">S.No</th>
                    <th className="border px-4 py-2">Items Category</th>
                    <th className="border px-4 py-2">Items Name</th>
                    <th className="border px-4 py-2">Date of Opening Stock</th>
                    <th className="border px-4 py-2 w-16">Qty.</th>
                    <th className="border px-4 py-2">U.O.M</th>
                    <th className="border px-4 py-2 w-36">Value</th>
                    {!updateScreenTitle && (
                      <th className="border px-4 py-2">Action</th>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {tableData.map((row, index) => {
                    // Get the selected Item Names in other rows of tableData
                    const selectedItemIds = tableData
                      .filter((_, i) => i !== index) // Exclude the current row
                      .map(({ MstItemId }) => MstItemId)
                      .filter((id) => id); // Only include non-empty IDs

                    // Get Item Names from bindOpeningStockData (submitted records)
                    const submittedItemIds = bindOpeningStockData
                      .filter(
                        (submittedRow) =>
                          // Exclude the current row's TxnOpeningstockId during editing
                          !row.TxnOpeningstockId ||
                          submittedRow.TxnOpeningstockId !==
                            row.TxnOpeningstockId
                      )
                      .map(({ MstItemId }) => MstItemId)
                      .filter((id) => id);

                    // Combine selected and submitted Item IDs, ensuring no duplicates
                    const excludedItemIds = [
                      ...new Set([...selectedItemIds, ...submittedItemIds]),
                    ];

                    // Filter Item Names to exclude those already selected or submitted
                    const filteredItemNameOptions = row.MstItemcategoryId
                      ? ItemNameOptions.filter(
                          (item) =>
                            item.MstItemCategoryId === row.MstItemcategoryId &&
                            !excludedItemIds.includes(item.value)
                        )
                      : [];

                    return (
                      <tr key={index}>
                        <td className="border px-2 py-2">{index + 1}</td>
                        <td className="border px-2 py-2 w-[160px] relative overflow-visible">
                          <div className="w-52"></div>
                          <AutoDropDown
                            Class="custom-class"
                            options={
                              formFields.itemType
                                ? itemsOptions.filter(
                                    (cat) =>
                                      cat.MstItemTypeId === formFields.itemType
                                  )
                                : []
                            }
                            placeholder="Select"
                            name="MstItemcategoryId"
                            selectedOption={
                              row.MstItemcategoryId
                                ? itemsOptions.find(
                                    (x) => x.value === row.MstItemcategoryId
                                  )
                                : null
                            }
                            controlFunc={(e) =>
                              handleInputChange(e, index, "MstItemcategoryId")
                            }
                          />
                        </td>
                        <td className="border px-2 py-2 w-[160px] relative overflow-visible">
                          <div className="w-52"></div>
                          <AutoDropDown
                            Class="custom-class"
                            options={filteredItemNameOptions}
                            placeholder="Select"
                            name="MstItemId"
                            selectedOption={
                              row.MstItemId
                                ? ItemNameOptions.find(
                                    (x) => x.value === row.MstItemId
                                  )
                                : null
                            }
                            controlFunc={(e) =>
                              handleInputChange(e, index, "MstItemId")
                            }
                            //  controlFuncBlur={(value) => handleItemBlur(value, index, "MstItemId")}
                          />
                        </td>
                        <td className="border px-2 py-2 w-[130px]">
                          <InputText
                            inputType="date"
                            name="OpeningDate"
                            content={row.DateofOpeningStock}
                            disabled={updateScreenTitle}
                            controlFunc={(e) =>
                              handleInputChange(e, index, "DateofOpeningStock")
                            }
                          />
                        </td>
                        <td className="border px-2 py-2 w-[120px]">
                          <InputText
                            inputType="number"
                            name="Quantity"
                            min={0}
                            onKeyDown={(e) => {
                              if (e.key === "-" || e.key === "e")
                                e.preventDefault(); // blocks negative & scientific notation
                            }}
                            content={row.Quantity}
                            tooltip={
                              updateScreenTitle
                                ? `Quantity should not be less than: ${row.Difference}`
                                : ""
                            }
                            controlFunc={(e) =>
                              handleInputChange(e, index, "Quantity")
                            }
                            controlFuncBlur={(e) =>
                              handleQuantityBlur(e, index)
                            }
                          />
                        </td>
                        <td className="border px-2 py-2 w-[5px]">
                          <InputText
                            inputType="text"
                            name="UOM"
                            content={row.UOM}
                            controlFunc={(e) =>
                              handleInputChange(e, index, "UOM")
                            }
                            disabled={true}
                          />
                        </td>
                        <td className="border px-2 py-2 w-[140px]">
                          <InputText
                            inputType="number"
                            name="Value"
                            content={row.Value}
                            onKeyDown={(e) => {
                              if (e.key === "-" || e.key === "e")
                                e.preventDefault(); // blocks negative & scientific notation
                            }}
                            isAdd={true}
                            controlFunc={(e) => {
                              if (e.target.value.length <= 6) {
                                handleInputChange(e, index, "Value");
                              }
                            }}
                          />
                        </td>
                        {!updateScreenTitle && (
                          <td className="border px-4 py-2 w-[100px]">
                            <div className="flex gap-4 items-center justify-center">
                              <svg
                                viewBox="0 0 20 20"
                                fill="currentColor"
                                className="w-6 h-6 text-black cursor-pointer"
                                onClick={() => handleDeleteRow(index)}
                              >
                                <path d="M6 2l2-2h4l2 2h4v2H2V2h4zM3 6h14l-1 14H4L3 6zm5 2v10h1V8H8zm3 0v10h1V8h-1z" />
                              </svg>
                              {index === tableData.length - 1 && (
                                <svg
                                  viewBox="0 0 1024 1024"
                                  fill="currentColor"
                                  onClick={handleAddRow}
                                  className="w-6 h-6 text-black cursor-pointer"
                                >
                                  <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm192 472c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z" />
                                </svg>
                              )}
                            </div>
                          </td>
                        )}
                      </tr>
                    );
                  })}
                </tbody>
              </table>

              {tableError && (
                <p className="text-red-600 font-semibold text-sm mt-4">
                  {tableError}
                </p>
              )}
              {Object.keys(rowErrors).length > 0 && (
                <p className="text-red-600 font-semibold text-sm mt-4">
                  Quantity cannot be less than difference in one or more rows.
                </p>
              )}
              <div className="flex justify-center mt-[100px]">
                <Buttons
                  addScreenTitle={addScreenTitle}
                  updateScreenTitle={updateScreenTitle}
                  disabledBtn={submitBtnDisabled || isLoading}
                  handleSubmit={handleSubmit}
                  cancel={cancel}
                />
              </div>
            </div>
          </div>
        </div>
      )}
      {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}
      <MainPopup
        popUpOpen={popUpOpen}
        setpopUpOpen={setpopUpOpen}
        Open={handleStock}
      >
        <div>
          <PopUpScreenTitle
            title="Opening Stock"
            setpopUpOpen={setpopUpOpen}
            viewDetails={viewDetails}
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
          />
          <OpeningstockPopup data={OpeningStockData} data1={popupTableData} />
        </div>
        <PopUpButtons
          deleteDetails={deleteDetails}
          blockDetails={blockDetails}
          unBlockDetails={unBlockDetails}
          handleSubmit={handleSubmit}
          cancel={cancel}
          rowIndex={rowIndex}
          disabledBtn={submitBtnDisabled}
        />
      </MainPopup>
    </MainLayout>
  );
};

export default OpeningStock;
